/**
 * A plan's date: `YYYY-MM-DD`, and a day the calendar actually has.
 *
 * The shape alone lets "2026-99-99" through, and `new Date` of that is Invalid
 * Date — which `Intl.DateTimeFormat.format` throws on, mid-render. The server
 * typed this field as a date; this is that check.
 */

const DATE = /^(\d{4})-(\d{2})-(\d{2})$/

export function isCalendarDate(value: string): boolean {
  const match = DATE.exec(value)
  if (!match) return false
  const [year, month, day] = match.slice(1).map(Number)
  const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)
  const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1]
  return days !== undefined && day >= 1 && day <= days
}
